import type { Address, Contact } from '~api/address_book';

import { InputAddressToken, formatAddress, getAddressTemplate } from '@ingrid/address';

import { useLocalizeCountry } from '~src/i18n/localized-country';

import { Ellipsis } from '../Ellipsis/Ellipsis';

type AddressMultilineProps = Pick<Contact, 'email' | 'phone'> & {
  address?: Address;
  template?: string[];
};

export function AddressMultiline(props: AddressMultilineProps) {
  const { address, email, phone, template: templateOverride } = props;
  const localizeCountry = useLocalizeCountry();

  if (!address) {
    return null;
  }

  const { address_lines = [], city, country, name, postal_code, region } = address;

  const template = templateOverride ?? getAddressTemplate(country!);

  const tokens: InputAddressToken[] = [
    ...address_lines.map<[string, string]>((line, index) => [`address_line_${index + 1}`, line]),
    ['country', localizeCountry(country!)],
    ['city', city],
    ['name', name],
    ['postal_code', postal_code],
    ['region', region],
    ['email', email],
    ['phone', phone],
  ];

  const formattedAddress = formatAddress(tokens, {
    template: [...template, 'newline', 'email', 'newline', 'phone'],
    multiline: true,
  });

  return (
    <Ellipsis style={{ whiteSpace: 'pre-wrap' }} as="address">
      {formattedAddress}
    </Ellipsis>
  );
}
